module.exports = __webpack_public_path__ + "static/media/1001180TL.d10d9e95.jpg";